import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { JournalSectionPersonnelPage } from "@/features/journal-section-personnel";
import { routes } from "@shared/lib/react-router";
import { JournalsSectionSecond } from "./ui";
import { JournalSectionFormPage } from "./ui/journal-section-form-page";
import { JournalSectionInfoPage } from "./ui/journal-section-info-page";

export const JournalsSectionSecondRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.section2()}`,
    element: createElement(JournalsSectionSecond),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 2 }),
      },
      ...rest,
    ],
  };
};

export const JournalsSectionSecondVersionRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.journals.journalVersionSection2()}`,
    element: createElement(JournalsSectionSecond),
    children: [
      {
        path: `form/:itemNoVersionId?`,
        element: createElement(JournalSectionFormPage),
      },
      {
        path: `view/:itemNoVersionId`,
        element: createElement(JournalSectionInfoPage),
      },
      {
        path: "personnel",
        element: createElement(JournalSectionPersonnelPage, { sectionNumber: 2 }),
      },
      ...rest,
    ],
  };
};
